import { vappContainer } from '@/application';
import { logger as log } from '@common/logger';
import { MyProfilePageService } from '@pages/MyProfilePage/services';

const MODULE_NAME = 'profile.machines.states.sendOTP';

const getSrv = () => {
  return vappContainer.get<MyProfilePageService>(
    MyProfilePageService.displayName
  );
};

export const sendOTP = async (context: any, event: any) => {
  const currentState = 'SEND_OTP';
  const method = 'sendOTP';

  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      const content = await srv.agent.sendOTP(event?.payload);
      if (content) {
        return resolve({
          key: 'SEND_OTP_SUCCESS',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = 'Page content not found';
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: 'SEND_OTP_FAILED',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      return reject({
        key: 'SEND_OTP_FAILED',
        value: err?.message,
      });
    }
  });
};
